class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
        this.selector = this.dataset.selector;
        this.breakpoint = this.dataset.breakpoint || null;
        this.swiper = null;
        this.maxSlidesMobile = parseInt(this.dataset.maxSlidesMobile) || null;
        this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
        this.tabletMediaQuery = window.matchMedia('(min-width: 768px) and (max-width: 1024px)');
        this.dasktopMediaQuery = window.matchMedia('(min-width: 1024px)');
        window.addEventListener('minicart:updated', () => this.handleMinicartUpdatedForAccessories());
        this.handleAccessoriesReady = () => this.refreshSwiper();
    }

    connectedCallback() {
        this.addEventListener('po:cart-accessories:ready', this.handleAccessoriesReady);

        if (this.breakpoint && !window.matchMedia(`${this.breakpoint}`).matches) {
            window.addEventListener('resize', () => {
                if (window.matchMedia(`${this.breakpoint}`).matches) {
                    if (!this.swiper) {
                        this.initSlider();
                    }
                } else {
                    if (this.swiper) {
                        this.destroySlider();
                    }
                }
            });

            window.dispatchEvent(new Event('resize'));

            return;
        }

        if (this.querySelector(`.swiper.${this.selector}`)) {
            this.initSlider();
        }
    }

    disconnectedCallback() {
        this.removeEventListener('po:cart-accessories:ready', this.handleAccessoriesReady);
    }

    initSlider() {
        if (typeof Swiper !== 'undefined') {
            let swiperElement = this.querySelector(`.swiper.${this.selector}`);
            this.swiper = new Swiper(swiperElement, this.options);

            if (this.maxSlidesMobile && this.mobileMediaQuery.matches) {
                this.hideExtraSlidesOnMobile(this.maxSlidesMobile);
            }
        }
    }

    refreshSwiper() {
        if (this.swiper) {
            this.swiper.update();
            return;
        }

        if (this.querySelector(`.swiper.${this.selector}`)) {
            this.initSlider();
        }
    }

    destroySlider() {
        this.swiper.destroy();
        this.swiper = null;
    }

    handleEmptyAccessories() {
        const minicartContainer = document.querySelector('.po-minicart-container');
        const accessoriesContainer = document.querySelector('.po-minicart-accessories-container');
        const accessoriesTitle = document.querySelector('.accessories-title');
        const ctaContainer = document.querySelector('.po-cart-notification__links');
        const swiperElements = document.querySelector('.swiper-wrapper').childElementCount;

        if (swiperElements === 0) {
            accessoriesContainer.style.display = 'none'; 

            if(!this.mobileMediaQuery.matches) {
                accessoriesTitle.style.display = 'none'; 
            }

            if(this.tabletMediaQuery.matches) {
                ctaContainer.classList.add('po-cart-notification__links-fixed');
            }

            if(this.dasktopMediaQuery.matches) {
                minicartContainer.style.flexDirection = 'row-reverse';
            } else {
                minicartContainer.style.flexDirection = '';
            }

        }
    }

    handleMinicartUpdatedForAccessories() {
        this.handleEmptyAccessories();
        
        if (!this.swiper) return;

        const slideCount = this.swiper.slides.length;
        if (slideCount === 1) {
            this.destroySlider();
            document.querySelector('.po-swiper-pagination-bullet').style.display = 'none';
        }
    }

    /**
     * @param {Number} slideLimit - The number of slides to be shown on mobile
     */
    hideExtraSlidesOnMobile(slideLimit) {
        if (!this.swiper) return;

        const totalSlides = this.swiper.slides.length;
        const slidesToRemove = [];
        for (let i = slideLimit; i < totalSlides; i++) {
            slidesToRemove.push(i);
        }

        if (slidesToRemove.length > 0) {
            this.swiper.removeSlide(slidesToRemove);
        }
    }
}

customElements.define('swiper-slider', SwiperSlider);

class SwiperUtils {
    /**
     * @param {Object} swiper - The swiper instance to be updated.
     */
    static update(swiper) {
        swiper.update();
    }
}

class DinamicSwiper extends SwiperSlider {
  constructor() {
    super();
    this.tabs = this.dataset.tabs || '';
    this.swiperElement = this.querySelector(`.swiper.${this.selector}`);
    this.paginationContainer = this.swiperElement.querySelector('.swiper-pagination');
  }

  connectedCallback() {
    const swiperEl = this.querySelector(`.swiper.${this.selector}`);
  
    if (swiperEl) {
      if (
        this.options.pagination &&
        typeof this.options.pagination.renderBullet === 'string' &&
        this.options.pagination.renderBullet === 'renderTabBullet'
      ) {
        if (this.tabs && this.tabs.trim() !== '') {
          const tabLabels = this.tabs.split(',').map(label => label.trim());
  
          this.options.pagination.renderBullet = function (index, className) {
            return `<span class="${className}" role="tab">${tabLabels[index] || ''}</span>`;
          };
        } else {
          delete this.options.pagination.renderBullet;
        }
      }
  
      this.initSlider();
    }
  }

  initSlider() {
    let swiper;
    if (typeof Swiper !== 'undefined') {
      swiper = new Swiper(this.swiperElement, this.options);
    }

    swiper?.on('slideChange', () => {
      let activeBullet = this.swiperElement.querySelector('.swiper-pagination-bullet-active');

      if (activeBullet && this.paginationContainer) {
        const containerRect = this.paginationContainer.getBoundingClientRect();
        const bulletRect = activeBullet.getBoundingClientRect();

        const offset = bulletRect.left - containerRect.left - containerRect.width / 2 + bulletRect.width / 2;

        this.paginationContainer.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }
    });
    this.updateNavigationVisibility();

    // Ricalcola visibilità bottoni al resize
    window.addEventListener('resize', () => {
      this.updateNavigationVisibility();
    });
  }

  updateNavigationVisibility() {
    if (!this.paginationContainer) return;

    const totalWidth = this.paginationContainer.scrollWidth;
    const visibleWidth = this.paginationContainer.clientWidth;

    const shouldHide = totalWidth <= visibleWidth;

    const prevBtn = this.querySelector('.swiper-button-prev');
    const nextBtn = this.querySelector('.swiper-button-next');

    if (prevBtn) prevBtn.style.display = shouldHide ? 'none' : '';
    if (nextBtn) nextBtn.style.display = shouldHide ? 'none' : '';
  }
}

customElements.define('dinamic-swiper', DinamicSwiper);
